export default function () {
  return {
    gatePasses: [],
    gatePass: []
  }
}
